(() => {
  if (customElements.get('snuggli-delivery-estimate')) return;

  class SnuggliDeliveryEstimate extends HTMLElement {
    constructor() {
      super();
      this.refresh = this.refresh.bind(this);
      this.handleVisibility = this.handleVisibility.bind(this);
    }

    static deliveryDate(viewedAt) {
      const date = new Date(viewedAt);
      date.setHours(12, 0, 0, 0);

      for (let days = 0; days < 5;) {
        date.setDate(date.getDate() + 1);
        if (date.getDay() !== 0 && date.getDay() !== 6) days += 1;
      }

      return date;
    }

    static dateValue(date) {
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${date.getFullYear()}-${month}-${day}`;
    }

    connectedCallback() {
      window.addEventListener('pageshow', this.refresh);
      document.addEventListener('visibilitychange', this.handleVisibility);
      this.refresh();
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
      window.removeEventListener('pageshow', this.refresh);
      document.removeEventListener('visibilitychange', this.handleVisibility);
    }

    handleVisibility() {
      if (document.visibilityState === 'visible') this.refresh();
    }

    refresh() {
      clearTimeout(this.timer);
      const now = new Date();
      const date = SnuggliDeliveryEstimate.deliveryDate(now);
      if (date.getDay() === 0) date.setDate(date.getDate() - 1);
      const time = this.querySelector('[data-delivery-date]');
      const result = this.querySelector('[data-delivery-result]');
      const fallback = this.querySelector('[data-delivery-fallback]');

      if (time && result && fallback) {
        time.dateTime = SnuggliDeliveryEstimate.dateValue(date);
        const parts = new Intl.DateTimeFormat('en-GB', {
          weekday: 'short',
          day: 'numeric',
          month: 'short'
        }).formatToParts(date);
        const formatted = Object.fromEntries(parts.map(({ type, value }) => [type, value]));
        time.textContent = `${formatted.weekday}, ${formatted.day} ${formatted.month}`;
        result.hidden = false;
        fallback.hidden = true;
      }

      const midnight = new Date(now);
      midnight.setHours(24, 0, 0, 0);
      this.timer = setTimeout(this.refresh, midnight.getTime() - now.getTime() + 50);
    }
  }

  customElements.define('snuggli-delivery-estimate', SnuggliDeliveryEstimate);
})();
